import { Link, useParams } from "react-router-dom";
import { ArrowLeft, ArrowRight, CheckCircle2 } from "lucide-react";
import { useContent, useSite } from "../context/SiteContext";
import { ServiceCard } from "../components/site/Sections";
import { ServiceIcon } from "../components/site/Brand";
import { PageHero } from "./PublicLayout";
import { fileUrl } from "../lib/api";

function Detail({ s, i }) {
  return (
    <section className="pt-32 pb-24 px-5 lg:px-8" data-testid="service-detail">
      <div className="max-w-4xl mx-auto">
        <Link to="/services" className="inline-flex items-center gap-2 text-[#00d9ff] font-cond uppercase tracking-wider" data-testid="service-back-link"><ArrowLeft className="w-4 h-4" /> All services</Link>
        <div className="card-neon mt-6 p-6 sm:p-10">
          <div className="flex items-start gap-5">
            <span className="icon-ring w-20 h-20 shrink-0"><ServiceIcon name={s.icon} className="w-10 h-10" /></span>
            <div>
              <p className="eyebrow">Service {i + 1}</p>
              <h1 className="font-display text-5xl sm:text-6xl text-metal">{s.title}</h1>
              {s.badge && <span className="inline-block mt-2 px-3 py-0.5 rounded bg-[#0a3a9a] text-white text-xs font-bold tracking-widest">{s.badge}</span>}
            </div>
          </div>
          {s.image && <img src={fileUrl(s.image)} alt={s.title} className="mt-6 w-full rounded-xl border border-[#007bff]/30" />}
          <p className="mt-6 text-lg text-slate-200 whitespace-pre-line">{s.details || s.description}</p>
          {s.bullets?.length > 0 && (
            <ul className="mt-5 grid sm:grid-cols-2 gap-3">
              {s.bullets.map((b) => <li key={b} className="flex items-center gap-2 bg-[#061232] rounded-lg p-3 border border-[#007bff]/25"><CheckCircle2 className="w-5 h-5 text-[#00d9ff]" />{b}</li>)}
            </ul>
          )}
          <p className="mt-6 text-slate-400">Pricing depends on your current and target goals. Request a quotation to receive pricing for your specific order.</p>
          <Link to={`/quote?service=${s.slug}`} className="btn-electric mt-6" data-testid="service-detail-quote-btn">Get a Quote <ArrowRight className="w-4 h-4" /></Link>
        </div>
      </div>
    </section>
  );
}

export default function ServicesPage() {
  const { slug } = useParams();
  const { site } = useSite();
  const c = useContent("services_section");
  const services = site?.services || [];
  const idx = services.findIndex((s) => s.slug === slug);
  if (slug && idx >= 0) return <Detail s={services[idx]} i={idx} />;
  return (
    <div data-testid="services-page">
      <PageHero eyebrow={c.eyebrow} white={c.title_white} blue={c.title_blue} desc={c.description} />
      <div className="max-w-6xl mx-auto px-5 lg:px-8 py-16 grid gap-5 md:grid-cols-2">
        {services.map((s, i) => <ServiceCard key={s.id} s={s} i={i} featured={i === 0} />)}
      </div>
    </div>
  );
}
